module.exports = __webpack_public_path__ + "078d7795b317832490558ac3aa1199e6.svg";